import { MicVAD } from '@ricky0123/vad-web';

let stream: MediaStream | null = null;

export async function createMicController(
  handleSpeechStart: () => void,
  handleSpeechEnd: (audio: Int16Array) => void,
  setUserAudioLevel: React.Dispatch<React.SetStateAction<number>>,
  volumeIntervalRef: React.MutableRefObject<number | null>
) {
  // const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  if (!stream)
    throw new Error(
      'No microphone stream available. Please check microphone permissions.'
    );

  // Create volume analyser
  const audioCtx = new AudioContext();
  const analyser = audioCtx.createAnalyser();
  analyser.fftSize = 512;

  const micSource = audioCtx.createMediaStreamSource(stream);
  micSource.connect(analyser);

  const data = new Uint8Array(analyser.frequencyBinCount);

  function getVolume() {
    analyser.getByteTimeDomainData(data);
    let sum = 0;
    for (let i = 0; i < data.length; i++) {
      const value = (data[i] - 128) / 128;
      sum += value * value;
    }
    const rms = Math.sqrt(sum / data.length);
    return rms * 100;
  }

  const vad = await MicVAD.new({
    stream,
    // positiveSpeechThreshold: 0.8, //detecting speech sensitive 0 - 1 is less sensitive
    // negativeSpeechThreshold: 0.5, //stops detecting speech 0 - 1 is fastest
    redemptionFrames: 15, // waits for 30 frames (~0.5 seconds) of silence before onSpeechEnd
    // minSpeechFrames: 10, // minimum frames to consider speech valid
    onSpeechStart: () => {
      volumeIntervalRef.current = window.setInterval(() => {
        const vol = getVolume();
        setUserAudioLevel(vol * 10 > 100 ? 100 : vol * 10);
      }, 200);
      handleSpeechStart();
    },
    onVADMisfire: () => {
      if (volumeIntervalRef.current !== null) {
        clearInterval(volumeIntervalRef.current);
      }
    },

    onSpeechEnd: (audio) => {
      handleSpeechEnd(floatTo16BitPCM(audio));
      if (volumeIntervalRef.current !== null) {
        clearInterval(volumeIntervalRef.current);
      }
    }
  });
  vad.start();

  return vad;
}

export async function checkMicPermission() {
  try {
    stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    // if (stream) {
    //   stream.getTracks().forEach((track) => track.stop());
    // }
    return true;
  } catch (err: any) {
    if (err.name === 'NotAllowedError') {
      console.warn('User denied microphone access.');
    } else if (err.name === 'NotFoundError') {
      console.warn('No microphone found.');
    } else {
      console.warn('Error accessing microphone:', err);
    }
    return false;
  }
}

export function stopMicStream() {
  if (stream) {
    stream.getTracks().forEach((track) => track.stop());
    stream = null;
  }
}

function floatTo16BitPCM(audio: Float32Array): Int16Array {
  const int16Buffer = new Int16Array(audio.length);
  for (let i = 0; i < audio.length; i++) {
    let s = Math.max(-1, Math.min(1, audio[i]));
    int16Buffer[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
  }
  return int16Buffer;
}
